window.SiteReady(($) => {

  console.log('Init Block: Marquee');

  let $marquees = $('.js-marquee');

  $marquees.each((index, el) => {
    let $marquee = $(el);
    let $items = $marquee.find('.js-marquee_items');

    $items.after($items.clone().removeClass('js-marquee_items').addClass('js-marquee_clone'));
  });

  $(window).on('resize', (e) => {
    $marquees.each((index, el) => {
      let $marquee = $(el);
      let $items = $marquee.find('.js-marquee_items');
      let width = -($items[0].offsetWidth);

      el.style.setProperty('--scroll_end', width + 'px');
    });
  }).trigger('resize');

});